import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const NoHotelsMessage = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const hotels = booking.bookingHotels;

  return (
    <>
      {" "}
      {!hotels || hotels.length < 1 ? (
        <p>{t("bookingDetails.hotels.notice")}</p>
      ) : (
        ""
      )}
    </>
  );
};

export default NoHotelsMessage;
